import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'statusCode',
    standalone: false
})
export class StatusCodePipe implements PipeTransform {

  statuses = [
    {
      code: 1,
      alias: 'Stop',
      name: 'Stop',
      description: 'Turbine stopped',
      explanation: 'No data',
      color: '#b3b9bd'
    },
    {
      code: 2,
      alias: 'Stdby',
      name: 'Standby',
      description: 'Turbine is in standby',
      explanation: 'Wind under cut-in',
      color: '#000'
    },
    {
      code: 3,
      alias: 'Str',
      name: 'Starting',
      description: 'Turbine is starting',
      explanation: 'In service',
      color: '#4a90e2'
    },
    {
      code: 4,
      alias: 'Run',
      name: 'Running',
      description: 'Turbine is running in normal operation',
      explanation: 'Alarm stop',
      color: '#df000f'
    },
    {
      code: 5,
      alias: 'Free',
      name: 'Free running',
      description: 'Turbine is in freerun with the generator disconnected',
      explanation: 'Underperforming',
      color: '#ffcb00'
    },
    {
      code: 6,
      alias: 'Brk',
      name: 'Braking',
      description: 'Turbine is braking',
      explanation: 'Starting operation',
      color: '#89ff89'
    },
    {
      code: 7,
      alias: 'Free',
      name: 'Free running',
      description: 'Turbine is in freerun with the generator disconnected',
      explanation: 'Performing OK',
      color: '#00d700'
    }
  ];

  transform(value: number, key: string): string {
    let statusFound = this.statuses.find(status => status.code === value);

    if (statusFound === undefined) {
      statusFound = this.statuses[0];
    }

    return statusFound[key];
  }

}
